import { Component, OnInit } from '@angular/core';
import { blog, category } from '../shared/models/blog';
import { Router, ActivatedRoute } from '@angular/router';
import { BlogService } from '../shared/services/blog.service';
import * as AOS from 'aos';
import { CommonapiService } from '../shared/services/commonapi.service';
import {Title } from "@angular/platform-browser";
//jquery declaration
declare var $: any;

@Component({
  selector: 'app-blogquestion',
  templateUrl: './blogquestion.component.html',
  styleUrls: ['./blogquestion.component.css']
})
export class BlogquestionComponent implements OnInit {
  allBlogs: blog[];
  blogs: blog;
  recentPost: blog[];
  objCategory: category[];
  searchHeading: string = "";
  selectedCategory: any = new Array();
  isSelectedTotal: number = 0;
  blogname:string="";
  name: string = "";
  company: string = "";
  phone: string = "";
  email: string = "";
  comments: string = "";
  distributionemaillist: string = '';
  blogheading:string='';

  constructor(
    private service: BlogService,
    public router: Router,
    private activeRoute: ActivatedRoute,
    private commonApiService: CommonapiService,
    private titleService: Title,
  ) { }

  async ngOnInit() {
    AOS.init();

    this.objCategory = new Array();
    await this.service.getBlogs().then(data => {
      this.allBlogs = data;
      this.recentPost = data;

      this.objCategory.push({
        category: "ALL",
        total: 0,
        checked: true
      });

      const _category = this.allBlogs.filter(
        (thing, i, arr) => arr.findIndex(t => t.category === thing.category) === i
      );

      _category.forEach((value) => {
        this.objCategory.push({
          category: value.category,
          total: 0,
          checked: true
        });
      });

      this.allBlogs.forEach(element => {
        this.selectedCategory.push(element.category);
      });
    })

    await this.activeRoute.params.subscribe(routeParams => {
      this.service.getBlogs().then(Data => {
        this.blogs = Data.filter(x => x.id==routeParams.id)[0];

        //this.domSanitizerService.bypassSecurityTrustHtml(this.blogs.description);
        console.log(this.blogs);
        this.titleService.setTitle(this.blogs.heading +" - SFI Compliance, Inc");
        this.topposition();

      })
    });

    let _dt = await this.commonApiService.getData("/api/MarketingController/DBGetDistributionList").toPromise();

    if (_dt && _dt[0].DataSet && _dt[0].DataSet.EmailList) {
      console.log(_dt[0].DataSet.EmailList);
      this.distributionemaillist = _dt[0].DataSet.EmailList;
    }
    //this.distributionemaillist="asif.sorathiya@pegasusinfocorp.com";
  }

  topposition() {

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }

  goToDetailsPage(id: number): void {
    this.router.navigateByUrl("/blogdetail/" + id);
  }

  gotosafetypage() {
    this.router.navigateByUrl("/blog");
  }

  ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return (true)
    }
    return (false)
  }

  async sendmessage() {

    if (this.name === "") {
      alert("Please Enter Your Name");
      document.getElementById("name").focus();
      return;
    }
    else if (this.company === "") {
      alert("Please Enter Your Company");
      document.getElementById("company").focus();
      return;
    }
    else if (this.email === "") {
      alert("Please Enter Your Email Address");
      document.getElementById("email").focus();
      return;
    }
    else if (this.email !== "" && this.ValidateEmail(this.email) === false) {
      alert("Please Enter Valid Email Address");
      document.getElementById("email").focus();
      return;
    }
    else if (this.phone === "") {
      alert("Please Enter Your Phone Number");
      document.getElementById("phone").focus();
      return;
    }
    else if (this.comments === "") {
      alert("Please Enter Your Question");
      document.getElementById("comments").focus();
      return;
    }

    const _obj = {
      EmailList: this.distributionemaillist,      
      Subject: this.name + " contacted SFI from " + this.email +" for blog "+this.blogs.heading,
      Body: "<p>Hi SFI,</p><p>Name: " + this.name + "</p><p>Organization: " + this.company + "</p>" +
        "<p>Email: " + this.email + "</p><p>Phone: " + this.phone + ",</p><p>My Question is : " + this.comments + " </p>"
    };
    console.log(_obj);
    let _dt = await this.commonApiService.postData("/api/MarketingController/EmailNotification", _obj).toPromise();

    if (_dt && _dt[0].DataSet) {
      alert(_dt[0].DataSet);
      if (_dt[0].DataSet === "Email Sent Successfully") {
        this.name = "";
        this.company = "";
        this.phone = "";
        this.email = "";
        this.comments = "";
      }
    }
  }

}
